import { z } from "zod";

import { constantsData } from "@/data";

export const calculateOfflineDataSourceAmountFieldFormSchema = z.object({
    condition: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    firstAmountType: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    secondAmountType: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
